import React, { Suspense, lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { ErrorProvider } from '@/contexts';
import { LoaderProvider } from '@/contexts';
import { ErrorBoundaryWithContext } from '@/errors';
import { PageNotFound } from '@/layout/common-pages';
import { ROUTES } from '@/constants/routes';

// Import route modules
import { publicRoutes } from './routes/publicRoutes';
import { alertRoutes } from './routes/alertRoutes';
import { resourceRoutes } from './routes/resourceRoutes';
import { adminRoutes } from './routes/adminRoutes';
import { releaseRoutes } from './routes/releaseRoutes';
import { agentRoutes } from './routes/agentRoutes';
import { reportRoutes } from './routes/reportRoutes';

// Lazy load root layout
const SOSAppRootLayout = lazy(() => import('@/pages/app-layout'));

// Custom browser history
export const customHistory = createBrowserHistory();

/**
 * Main router configuration
 * Combines all route modules into a single router instance
 */
const routes = [
  {
    path: ROUTES.HOME,
    element: (
      <ErrorProvider>
        <LoaderProvider>
          <ErrorBoundaryWithContext>
            <Suspense fallback={null}>
              <SOSAppRootLayout />
            </Suspense>
          </ErrorBoundaryWithContext>
        </LoaderProvider>
      </ErrorProvider>
    ),
    errorElement: <PageNotFound />,
    children: [
      // Public routes
      ...publicRoutes,

      // Alert routes
      alertRoutes,

      // Admin routes
      adminRoutes,

      // Resource routes
      resourceRoutes,

      // Release management routes
      ...releaseRoutes,

      // Agent routes
      ...agentRoutes,

      // Report routes
      ...reportRoutes,
    ],
  },
];

// Export router instance
export default createBrowserRouter(routes, { history: customHistory });
